import React from 'react'
import ViewEditEventManagementList from '../../features/eventManagement/ViewEditEventManagementList'

const ViewEditEventManagement = () => {
    return (
        <ViewEditEventManagementList />
    )
}

export default ViewEditEventManagement